import { Form } from 'antd';
import styled from 'styled-components';
import { Collapse } from 'UI';

export const MainContainer = styled.div`
  display: flex;
  width: 100%;
  padding-top: 1.5rem;
`;

export const FormContainer = styled(Form)`
  width: 100%;
`;

export const AdvanceInfoCollapse = styled(Collapse)`
  max-width: 100%;
`;

export const HorizontalContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  align-items: center;
  padding-bottom: 1.5rem;
`;

export const BaseFormItem = styled(Form.Item)`
  margin: 0;
  min-width: 180px

  & > * {
    width: 100%;
  }
`;
